<template>
  <div class="app-container" v-if="form">
    <el-card>
      <div class="back-box">
        <div @click="handleBack">
          <img src="../../../assets/back.png" alt="" />
          <span>返回</span>
        </div>
      </div>
      <div class="title-box"><span class="txt1">商品基础信息</span></div>
      <el-descriptions>
        <el-descriptions-item label="活动名称">{{form.name}}</el-descriptions-item>
        <el-descriptions-item label="税收分类编码">{{form.taxCode}}</el-descriptions-item>
        <el-descriptions-item label="商品主图"><el-image style="width: 50px; height: 50px" :src="form.img" :preview-src-list="[form.img]"></el-image></el-descriptions-item>
        <el-descriptions-item label="商品Banner图">
          <div v-if="form.bannerImg">
            <el-image class="banner-box" style="width: 50px; height: 50px" v-for="(item,index) in form.bannerImg && form.bannerImg.split(',')" :key="index" :src="item" :preview-src-list="[item]"></el-image>
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="市场价">{{form.retailPrice}}</el-descriptions-item>
        <el-descriptions-item label="活动价格">{{form.actPrice}}</el-descriptions-item>
        <el-descriptions-item label="是否限购">{{form.isQuota?'限购':'不限购'}}</el-descriptions-item>
        <el-descriptions-item label="是否包邮">{{form.isPostage?'包邮':'不包邮'}}</el-descriptions-item>
        <el-descriptions-item label="限购数量">{{form.quotaNum}}</el-descriptions-item>
        <el-descriptions-item label="虚拟销售量">{{form.virtualSalesCount}}</el-descriptions-item>
        <el-descriptions-item label="秒杀份数">{{form.salesNum}}</el-descriptions-item>
        <el-descriptions-item label="活动时间"> {{form.listingStartTime}} ~ {{form.listingEndTime}}</el-descriptions-item>
        <el-descriptions-item label="是否开启快递邮寄" v-if="form.isOpenMailing"> {{form.isOpenMailing?'开启':'关闭'}}</el-descriptions-item>
        <el-descriptions-item label="是否开启到店自提" v-if="form.isOpenSelfPickup"> {{form.isOpenSelfPickup?'开启':'关闭'}}</el-descriptions-item>
        <el-descriptions-item label="是否APP展示">{{form.isShowApp===1?'展示':'不展示'}}</el-descriptions-item>
        <el-descriptions-item label="是否开票">
          {{form.canInvoice===1?'支持':'不支持'}}
        </el-descriptions-item>
      </el-descriptions>
      <template v-if="form.pickupAddressList && form.pickupAddressList.length > 0">
        <el-descriptions title="到店自提地址"></el-descriptions>
        <el-table :data="form.pickupAddressList">
          <el-table-column label="活动名字" prop="name" align="center" />
          <el-table-column label="核销人信息" align="center">
            <template slot-scope="scope">
              {{ scope.row.writeoffAuthNameList || (scope.row.writeoffAuthList && scope.row.writeoffAuthList.map(auth => `${auth.userRealName  || ''}(${auth.userLevelName || ''})(${auth.userMobile || ''})`).join('、')) || '-' }}
            </template>
          </el-table-column>
          <el-table-column label="自提地点" prop="address" align="center" />
          <el-table-column label="自提时间" prop="pickupTime" align="center">
            <template slot-scope="scope">
              <span v-if="!scope.row.pickupTime">不限制自提时间</span>
              <span v-else-if="Array.isArray(scope.row.pickupTime)">{{ scope.row.pickupTime.join(' - ') }}</span>
              <span v-else>{{ scope.row.pickupTime }}</span>
            </template>
          </el-table-column>

        </el-table>
      </template>
      <template v-if="form.giftData.length > 0">
        <el-descriptions title="正价商品"></el-descriptions>
        <el-table :data="form.giftData">
          <el-table-column label="商品" prop="name" align="center" />
          <el-table-column label="规格" align="center">
            <template slot-scope="{row}">
              {{row.spec || '无规格值'}}
            </template>
          </el-table-column>
          <!-- REQ-2026-234328：上面那列「规格」是 SKU 规格值，这列是商品级规格
               （回收 product_spec 后取 sys_goods.spec），两列不同源，不能合并。 -->
          <el-table-column label="商品规格" align="center">
            <template slot-scope="{row}">
              {{row.productSpec || '-'}}
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="num" align="center" />
          <el-table-column label="商品价格" prop="price" align="center" />
        </el-table>
      </template>
      <template v-if="form.giftData1.length > 0">
        <el-descriptions title="赠品商品"></el-descriptions>
        <el-table :data="form.giftData1">
          <el-table-column label="商品" prop="name" align="center" />
          <el-table-column label="规格" align="center">
            <template slot-scope="{row}">
              {{row.spec || '无规格值'}}
            </template>
          </el-table-column>
          <el-table-column label="商品规格" align="center">
            <template slot-scope="{row}">
              {{row.productSpec || '-'}}
            </template>
          </el-table-column>
          <el-table-column label="数量" prop="num" align="center" />
        </el-table>
      </template>
      <div class="title-box"><span class="txt1">权限</span></div>
      <el-descriptions :column="1">
        <el-descriptions-item label="购买权限">{{form.sysbuyNameList}}</el-descriptions-item>
        <el-descriptions-item label="查看权限">{{form.sysLookNameList}}</el-descriptions-item>
      </el-descriptions>
      <!-- <div class="title-box"><span class="txt1">服务配置</span></div>
      <el-descriptions>
        <el-descriptions-item label="服务配置"></el-descriptions-item>
      </el-descriptions> -->

      <div class="title-box"><span class="txt1">活动详情</span></div>
      <div class="custom bg">商品详情：
        <div v-html="form.details"></div>
      </div>
      <el-descriptions>
        <el-descriptions-item label="商品排序">{{form.sort}}</el-descriptions-item>
        <el-descriptions-item label="状态">{{form.state === 1?'启用':'禁用'}}</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import sysGoodsApi from '@/api/goods/sysGoods'
export default {
  props: ['rowItem'],
  data() {
    return {
      activeName: 'first',
      list: [],
      form: null,
      tabType: 1,
      shareData: null
    }
  },
  created() {
    this.handleShow()
  },
  methods: {
    handleShow() {
      sysGoodsApi.fetchById(this.rowItem.id)
        .then((data) => {
          this.form = data.data;
          this.calcEditData()

        })
    },
    calcEditData() {
      let { sysGoodsPackageConfigShowList, sysGoodsSpecValuecombineList } = this.form;
      this.$set(this.form, 'retailPrice', sysGoodsSpecValuecombineList[0].retailPrice);
      //正价商品 赠品商品
      let arr = [], arr1 = []
      sysGoodsPackageConfigShowList.forEach(item => {
        if (item.isGift) arr.push(item)
        else arr1.push(item)
      })
      this.$set(this.form, 'giftData1', arr);
      this.$set(this.form, 'giftData', arr1);

    },
    handleBack() {
      this.$emit('handleShow', '', 1)
    }
  }

}
</script>

<style lang="scss" scoped>
.custom {
  font-size: 14px;
  color: #2e2f3e;
  padding: 20px;
  margin: 10px 0;
  &.bg {
    // border-bottom: 1px solid #CCE2D1
    background-color: #eff8fd;
  }
}
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.tab-box {
  margin-bottom: 40px;
  span {
    font-size: 16px;
    color: #000000;
    cursor: pointer;
    padding-right: 48px;
    &.active {
      color: #5dbde7;
    }
  }
}
</style>
